import { useCxt } from "./StructureProvider";
import PropTypes from "prop-types";
import { useState } from "react";
import SingleDraw from "./SingleDraw";

function Draw({ stage, work, callBack }) {
	const {leagueStructure} = useCxt();
	
	const rule = leagueStructure[stage].works[work].rule;
	const ranges = leagueStructure[stage].works[work].range;
	const [drawN, setDrawN] = useState(0);

	function singleDrawCallBack() {
		if (drawN + 1 === ranges.length) {setDrawN(0); callBack();} else setDrawN(prev => prev + 1);
	}
	
	return <SingleDraw stage={stage} work={work} rule={rule} range={ranges[drawN]} callBack={singleDrawCallBack}/>;
}

Draw.propTypes = {
	stage: PropTypes.number,
	work: PropTypes.number,
	callBack: PropTypes.func,
}

export default Draw;